module.exports = __webpack_public_path__ + "static/media/notifications.9530725b.svg";